import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './regcomplete.css';

const RegComplete = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);
  
  useEffect(() => {
    if (countdown === 0) {
      navigate('/login');
      return;
    }
    const timer = setTimeout(() => {
      setCountdown(prev => prev - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <p>Thank you for registering for the conference.</p>
        <p>We have sent an email to hello@example.com.</p>
        <p>
          Please open your inbox and click the link in the email you received to verify your account.
        </p>
        <p>
          Redirecting in <span className="countdown">{countdown}</span> second{countdown !== 1 ? 's' : ''}...
        </p>
      </div>
    </div>
  );
};

export default RegComplete;
